// Antd
import { Divider } from 'antd'

// Interfaces
import { IBaseDividerProps } from './interfaces'

const BaseDivider = (props: IBaseDividerProps) => {
  return <Divider {...props} style={{ marginTop: 12, ...props?.style }} />
}

export { BaseDivider }
